import { useEffect, useRef } from "react"
import { GrowthBook, GrowthBookProvider } from "@growthbook/growthbook-react"
import { autoAttributesPlugin, growthbookTrackingPlugin } from "@growthbook/growthbook/plugins"

function createGrowthBookInstance() {
    return new GrowthBook({
        apiHost: process.env.NEXT_PUBLIC_GROWTHBOOK_API_HOST,
        clientKey: process.env.NEXT_PUBLIC_GROWTHBOOK_CLIENT_KEY,
        enableDevMode: process.env.NODE_ENV !== "production",
        plugins: [
            growthbookTrackingPlugin(),
            ...(typeof window !== "undefined"
                ? [
                      autoAttributesPlugin({
                          uuidKey: "device_id", // align with GB Managed Warehouse
                          uuidCookieName: "gb_device_id",
                      }),
                  ]
                : []),
        ],
        trackingCallback: (experiment, result) => {
            if (process.env.NODE_ENV !== "production") {
                console.debug("[GrowthBook] Exposure:", experiment.key, "=", result.variationId)
            }
        },
    })
}

export function GrowthBookProviderWrapper({ children }) {
    const gbRef = useRef(null)
    if (gbRef.current === null) {
        gbRef.current = createGrowthBookInstance()
        // TEMP: force variant 1 for testing — remove before merging
        // gbRef.current.setForcedVariations({ "tct2026-nav-arrangement": 1 })
    }

    useEffect(() => {
        const gb = gbRef.current
        if (!gb) return

        gb.init({ timeout: 1000, streaming: true }).finally(() => {
            document.documentElement.classList.remove("gb-loading")
        })
    }, [])

    return <GrowthBookProvider growthbook={gbRef.current}>{children}</GrowthBookProvider>
}
